import React, { useState, useEffect } from "react";
import { BACKEND_URL } from "../../../config";

function Orders() {

  const [orders, setOrders] =
    useState([]);

  const [loading, setLoading] =
    useState(true);


  useEffect(() => {

    fetchOrders();

  }, []);



  // ================= FETCH ORDERS =================

  const fetchOrders = async () => {

    try {

      const response =
        await fetch(

          `${BACKEND_URL}/api.php?module=orders&action=getAll`

        );

      const data =
        await response.json();

      setOrders(data.data || []);

    }

    catch (error) {

      console.log(error);

    }

    finally {

      setLoading(false);

    }

  };




  // ================= UPDATE STATUS =================

  const updateStatus =
    async (id, status) => {

      try {

        const response =
          await fetch(

            `${BACKEND_URL}/api.php?module=orders&action=updateStatus`,

            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json"
              },

              body:
                JSON.stringify({

                  id,
                  status

                })

            }

          );


        const data =
          await response.json();


        if (data.success) {

          fetchOrders();

        }

      }

      catch (error) {

        console.log(error);

      }

    };




  // ================= DELETE ORDER =================

  const handleDelete =
    async (id) => {

      if (

        !window.confirm(

          "Delete Order?"

        )

      ) return;



      await fetch(

        `${BACKEND_URL}/api.php?module=orders&action=delete&id=${id}`

      );


      fetchOrders();

    };




  if (loading) {

    return (

      <p>
        Loading...
      </p>

    );

  }




  return (

    <div className="admin-page">

      <h2>

        Orders

      </h2>



      <div className="admin-table">

        <table>


          <thead>

            <tr>

              <th>ID</th>

              <th>User ID</th>

              <th>Customer</th>

              <th>Email</th>

              <th>Total</th>

              <th>Payment</th>

              <th>Status</th>

              <th>Delete</th>

            </tr>

          </thead>




          <tbody>

            {

              orders.length > 0

                ?

                orders.map(

                  (order) => (

                    <tr
                      key={order.id}
                    >


                      <td>
                        ORD-{String(order.id).padStart(6, "0")}
                      </td>


                      <td>

                        {order.user_id}

                      </td>



                      <td>

                        {order.first_name}

                        {" "}

                        {order.last_name}

                      </td>



                      <td>

                        {order.email}

                      </td>



                      <td>
                        €{Number(order.total).toFixed(2)}
                      </td>



                      <td>

                        {order.payment_method}

                      </td>




                      <td>

                        <select

                          value={

                            order.order_status

                            ||

                            "Pending"

                          }


                          onChange={

                            (e) =>

                              updateStatus(

                                order.id,

                                e.target.value

                              )

                          }

                        >

                          <option value="Pending">

                            Pending

                          </option>


                          <option value="Processing">

                            Processing

                          </option>


                          <option value="Shipping">

                            Shipping

                          </option>


                          <option value="Delivered">

                            Delivered

                          </option>


                          <option value="Cancelled">

                            Cancelled

                          </option>

                        </select>


                      </td>




                      <td>

                        <button

                          className="admin-btn delete"

                          onClick={

                            () =>

                              handleDelete(

                                order.id

                              )

                          }

                        >

                          Delete

                        </button>


                      </td>


                    </tr>

                  )

                )

                :

                <tr>

                  <td
                    colSpan="8"
                    style={{
                      textAlign: "center"
                    }}
                  >

                    No Orders Found

                  </td>

                </tr>

            }

          </tbody>


        </table>

      </div>


    </div>

  );

}


export default Orders;